module.exports = __webpack_public_path__ + "static/media/discord.468da164.svg";